import { render, staticRenderFns } from "./CompetitionsViewQuestionsViewAnswer.vue?vue&type=template&id=23962afe&scoped=true&"
import script from "./CompetitionsViewQuestionsViewAnswer.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewQuestionsViewAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23962afe",
  null
  
)

export default component.exports